import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var Bookmarked = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M27 32a.999.999 0 01-.546-.163L16 25.02 5.546 31.837A1 1 0 014 31V1a1 1 0 011-1h22a1 1 0 011 1v30a1 1 0 01-1 1z" })), '0 0 32 32', 'Bookmarked');
//# sourceMappingURL=Bookmarked.js.map